const hideBar = () => {
  const closeButton = document.querySelector('.announcement-bar__close');
  const announcementBar = document.querySelector('.shopify-section--announcement-bar');
  if (closeButton && announcementBar) {
    const isBarClosed = localStorage.getItem('announcementBarClosed');
    if (isBarClosed === 'true') {
      announcementBar.classList.add('hide');
      document.documentElement.style.setProperty('--announcement-bar-is-sticky', '0');
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    } else if (!isBarClosed && announcementBar.classList.contains('hide')) {
      announcementBar.classList.remove('hide');
    }

    closeButton.addEventListener('click', function () {
      announcementBar.classList.add('hide');
      document.documentElement.style.setProperty('--announcement-bar-is-sticky', '0');
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      localStorage.setItem('announcementBarClosed', 'true');
    });
  }
};

const countdownTimer = () => {
  const countdownBlocks = document.querySelectorAll('[data-end-date]');

  countdownBlocks.forEach(function (block) {
    const endDate = block.getAttribute('data-end-date') + ' ' + block.getAttribute('data-end-time');
    const endDateParsed = new Date(endDate).getTime();
    const countdownElement = block.querySelector('.countdown-timer');
    if (block && countdownElement && endDate.length) {
      function updateCountdown() {
        const now = new Date().getTime();
        const distance = endDateParsed - now;

        if (distance < 0) {
          countdownElement.innerHTML = '...';
          countdownElement.classList.add('hidden');
          clearInterval(countdownInterval);
          return;
        }

        const totalHours = Math.floor(distance / (1000 * 60 * 60));
        const hours = totalHours % 24;
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdownElement.innerHTML = `${totalHours} <span>H</span> ` + (minutes > 0 ? `${minutes} <span>M</span> ` : '') + `${seconds} <span>S</span>`;
      }
      const countdownInterval = setInterval(updateCountdown, 1000);
      updateCountdown();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  hideBar();
  countdownTimer();
});
